import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
  selector: "jira-issue-icon",
  template: `<span [class]="issueTypeLowerCase" [uiTooltipTitle]="issueType" ui-tooltip></span>`,
  styleUrls: ["./jira-icon.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JiraIssueIconComponent {
  @Input()
  public issueType: string;

  public get issueTypeLowerCase(): string {
    return (this.issueType || "").toLowerCase();
  }
}
